"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const material_1 = require("@mui/material");
const useLabelStyles = ({ focused, hasError }) => {
    const theme = (0, material_1.useTheme)();
    const container = {
        position: 'relative',
        '& *': {
            fontWeight: 700,
        },
        '&.hasError': {
            '.inputContainer': {
                borderColor: theme.qlub.palette.danger.main,
            },
        },
    };
    const labelStyles = Object.assign(Object.assign({ fontWeight: 600, position: 'absolute', top: '-8px', left: '24px', padding: 'inherit', zIndex: 1, paddingInline: '6px' }, theme.qlub.typography.caption_overline), { color: theme.qlub.palette.iris.main, '&::after': {
            content: "' '",
            backgroundColor: theme.qlub.palette.white.main,
            width: '100%',
            height: '13px',
            position: 'absolute',
            left: 0,
            bottom: 0,
            zIndex: -1,
            boxSizing: 'border-box',
            display: 'inline-block',
        } });
    const inputContainer = {
        borderRadius: '8px',
        borderWidth: focused ? '2px' : '1px',
        borderStyle: 'solid',
        borderColor: hasError
            ? theme.qlub.palette.danger.main
            : focused
                ? theme.qlub.palette.iris.main
                : theme.qlub.palette.black.main,
        color: theme.qlub.palette.black.main,
        boxShadow: 'none !important',
        display: 'block',
        width: '100%',
        padding: '0.625rem 1.5rem',
        fontSize: '0.875rem',
        fontWeight: 400,
        lineHeight: '1.5',
        backgroundColor: theme.qlub.palette.white.main,
        backgroundClip: 'padding-box',
        transition: 'border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out',
    };
    return {
        container,
        labelStyles,
        inputContainer,
    };
};
exports.default = useLabelStyles;
